<template>
  <!-- 职业画像 -->
  <div class="page">
    <el-row :gutter="20" class="sameLayers">
      <el-col :span="24">
        <div class="grid-content ">
          <div class="generalBg_Virtualization"></div>
          <div class="dataSources">
            <div class="header">
              <div class="header_Virtualization"></div>
              <div class="header_title">
                <i class="h_icon header-icon"></i>
                <span style="margin-right:20px;">职业画像</span>
              </div>
              <span class="dataTime">数据采集时间：{{resultsBox.acquisitionTime}}</span>
              <i class="threePoints el-icon-more"></i>
            </div>

          </div>
        </div>
      </el-col>
    </el-row>
    
    <el-row :gutter="20" class="sameLayer">
      <div class="standards_content">
        <div class="project_box">
          <el-row :gutter="10" class="graphic" :class="this.$store.state.isScreen?'graphicQuanping':'graphicFeiquanp'">
            <el-col :span="24">
              <el-row :span="12" class="graphDistribute">
                <el-col :span="15">
                  <div class="figure_title">
                    <i class="h_icon icon-stars"></i>
                    薪资变动趋势
                  </div>

                  <div class="table-search-box">
                    <!-- @change="changeCityHandler" -->
                    <el-form :inline="true" :model="formResourceBase" class="demo-form-inline">
                      <el-form-item label="" >
                        <el-select v-model="formResourceBase.province" placeholder="请选择城市：" :popper-append-to-body="false"  clearable>
                          <el-option v-for="(item,index) in dropDownList.provinceList" :key="index" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                      </el-form-item>

                      <!-- @change="changeOccHandler" -->
                      <el-form-item label="" prop="uuid">
                        <el-select v-model="formResourceBase.uuid" placeholder="请选择职业：" :popper-append-to-body="false"  clearable>
                          <el-option v-for="(item,index) in dropDownList.occupation" :key="index" :label="item.name" :value="item.uuid"></el-option>
                        </el-select>
                      </el-form-item>
                      
                      <el-form-item>
                        <div class="search_button">
                          <i class="pointer el-icon-search" @click="search"></i>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                  
                  <div class="standards_content echartsHeight">
                    <discountChart :refId="'cloudvcolumnarChart'" :datas='SalaryTrend.dataList' :transverseData='SalaryTrend.transverseData' :colorList='SalaryTrend.colorList' :innerText="'单位：元/月'" :gridY="'25%'"></discountChart>
                  </div>
                </el-col>
                
                <el-col :span="9" class="Fristitle">
                  <div class="text">
                    <p>月平均薪资</p>
                    <p>{{SalaryTrend.extraData.name}}</p>
                    <p id="company">{{SalaryTrend.extraData.value}}元/月</p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-row>

    <el-row :gutter="20" class="sameLayer">
      <div class="standards_content">
        <div class="project_box">
          <el-row :gutter="10" class="graphic" :class="this.$store.state.isScreen?'graphicQuanping':'graphicFeiquanp'">
            <el-col :span="24">
              <el-row :span="12" class="graphDistribute">
                <el-col :span="15">
                  <div class="figure_title">
                    <i class="h_icon icon-stars"></i>
                    薪资区域排名TOP10
                  </div>

                  <div class="table-search-box table2">
                    <el-form :inline="true" :model="formResourceBase2" class="demo-form-inline">
                      <el-form-item label="">
                        <el-select v-model="formResourceBase2.uuid" placeholder="请选择职业：" :popper-append-to-body="false"  clearable>
                          <el-option v-for="(item,index) in dropDownList.occupation" :key="index" :label="item.name" :value="item.uuid"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item>
                        <div class="search_button">
                          <i class="pointer el-icon-search" @click="search2"></i>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>

                  
                  <div class="standards_content echartsHeight">
                    <vcolumnarChart :refId="'cloudvcolumnarChart'" :datas='MonthSalaryRank.dataList' :transverseData='MonthSalaryRank.transverseData' :colorList='MonthSalaryRank.colorList' :innerText="'单位：元/月'" :gridY="'25%'" :axisLabelInterval="true"></vcolumnarChart>
                  </div>
                </el-col>

                <el-col :span="9" class="Fristitle">
                  <div class="text">
                    <p>月平均薪资</p>
                    <p>{{MonthSalaryRank.maxArr.name}}</p>
                    <p id="company">{{MonthSalaryRank.maxArr.value}}元/月</p>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-row>

    <el-row :gutter="20" class="sameLayer">
      <div class="standards_content">
        <div class="project_box">
          <el-row :gutter="10" class="graphic" :class="this.$store.state.isScreen?'graphicQuanping':'graphicFeiquanp'">
            <el-col :span="24">
              <el-row :span="12" class="graphDistribute">
                <el-col :span="15">
                  <div class="figure_title">
                    <i class="h_icon icon-stars"></i>
                    招聘需求趋势
                  </div>

                  <div class="table-search-box">
                    <el-form :inline="true" :model="formResourceBase3" class="demo-form-inline">
                      <el-form-item label="">
                        <el-select v-model="formResourceBase3.province" placeholder="请选择城市：" :popper-append-to-body="false"  clearable>
                          <el-option v-for="(item,index) in dropDownList.provinceList" :key="index" :label="item.name" :value="item.name"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item label="">
                        <el-select v-model="formResourceBase3.uuid" placeholder="请选择职业：" :popper-append-to-body="false"  clearable>
                          <el-option v-for="(item,index) in dropDownList.occupation" :key="index" :label="item.name" :value="item.uuid"></el-option>
                        </el-select>
                      </el-form-item>
                      
                      <el-form-item>
                        <div class="search_button">
                          <i class="pointer el-icon-search" @click="search3"></i>
                        </div>
                      </el-form-item>
                    </el-form>
                  </div>
                  
                  <div class="standards_content echartsHeight">
                    <discountChart :refId="'cloudvcolumnarChart'" :datas='JobNeed.dataList' :transverseData='JobNeed.transverseData' :colorList='JobNeed.colorList' :innerText="'单位：个'" :gridY="'25%'"></discountChart>
                  </div>
                </el-col>

                <el-col :span="9" class="Secondtitle">
                  <div class="TitleText">
                    <p>最近{{JobNeed.lately.name}}{{this.formResourceBase3.city}}招聘岗位数:{{JobNeed.lately.value}}个</p>
                  </div>
                  <div class="city">
                    <div v-for="(item,index) in JobNeed.cityArr" :key="index">
                      <p>{{item.name}}</p>
                      <p id="company">{{item.value}}个</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>

import vcolumnarChart from '@/components/chart/vcolumnarChart.vue'; // 引入竖柱状图图表
import discountChart from '@/components/chart/discountChart.vue'; // 引入折线图图表

export default {
  components: {
    vcolumnarChart,
    // tcolumnarChart,
    discountChart
  },
  data() {
    return {
      formResourceBase: {
        province: '全国',
        uuid: ''
      },

      formResourceBase2: {
        uuid: ''
      },

      formResourceBase3: {
        province: '全国',
        uuid: '',
        city:''
      },
      
      colorList: ['#3B85FB', '#FD398E', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'], // 柱状图或折线图的颜色
      resultsBox: {
        reviousYear: '',
        followingYear: '',
        acquisitionTime: '',   //数据采集时间
      },

      dropDownList: {
        provinceList: [],
        occupation: []
      },
      SalaryTrend: {
        dataList: [],
        transverseData: [],
        colorList: [],
        extraData: {}
      },
      MonthSalaryRank:{
        dataList: [],
        transverseData: [],
        colorList: [],
        maxArr: {}
      },
      JobNeed: {
        dataList: [],
        transverseData: [],
        colorList: [],
        extraData: [],
        lately: {},
        cityArr: []
      },
    }
  },
  created() {
    this.obtainSubproject()
    this.getProvinceHandler()
    this.getOccupationHandler()

  },
  methods: {
    // 获取子项目数据源
    obtainSubproject() {
      this.$axios.post(this.$apiurls.puxitu_job_directory_and_version, {
        loading: false,
      }).then((res) => {
        if (res) {
          var dataTime = new Date()
          this.resultsBox.acquisitionTime = dataTime.getFullYear() + '年' + (dataTime.getMonth() > 10 ? dataTime.getMonth() : '0' + dataTime.getMonth()) + '月'
        }
      });
    },

    // 获取省份列表下拉
    getProvinceHandler() {
      this.$axios.post(this.$apiurls.puxitu_getProvinceGroup, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.dropDownList.provinceList = res.data.responseBody.data
          this.dropDownList.provinceList.unshift({name:'全国',value:'全国'})
        }
      });
    },

    // 获取职业列表下拉
    getOccupationHandler() {
      this.$axios.post(this.$apiurls.puxitu_getProfessionalTop10, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.dropDownList.occupation = res.data.responseBody.data.zhiye
          this.formResourceBase.uuid = res.data.responseBody.data.zhiye[0].uuid
          this.formResourceBase2.uuid = res.data.responseBody.data.zhiye[0].uuid
          this.formResourceBase3.uuid = res.data.responseBody.data.zhiye[0].uuid

          this.SalaryTrendHandler(this.formResourceBase.province,this.formResourceBase.uuid)
          this.MonthSalaryRankHandler(this.formResourceBase2.uuid)
          this.JobNeedHandler(this.formResourceBase3.province,this.formResourceBase3.uuid)

        }
      });
    },

    
    search(){
      this.SalaryTrendHandler(this.formResourceBase.province,this.formResourceBase.uuid)
    },
    search2(){
      this.MonthSalaryRankHandler(this.formResourceBase2.uuid)
    },
    search3(){
      this.JobNeedHandler(this.formResourceBase3.province,this.formResourceBase3.uuid)
    },

    SalaryTrendHandler(province,uuid) {
      let obj = {
        province:province,
        uuid:uuid
      }
      this.$axios.post(this.$apiurls.puxitu_getJobSalaryTrent, obj, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.SalaryTrend.transverseData = []
          this.SalaryTrend.dataList = []
          for (let i = 0; i < res.data.responseBody.data.name.length; i++) {
            this.SalaryTrend.transverseData.push(res.data.responseBody.data.name[i])
            this.SalaryTrend.dataList.push(res.data.responseBody.data.value[i])
          }
          this.SalaryTrend.colorList = this.colorList
          this.SalaryTrend.extraData = res.data.responseBody.data.extraValue[0]
        }
      });
    },

    MonthSalaryRankHandler(uuid){
      let Id = uuid

      this.$axios.post(this.$apiurls.puxitu_getAreaSalaryRank, Id, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.MonthSalaryRank.transverseData = []
          this.MonthSalaryRank.dataList = []
          for(let i = 0;i<res.data.responseBody.data.length;i++){
            this.MonthSalaryRank.dataList.push(res.data.responseBody.data[i].value)
            this.MonthSalaryRank.transverseData.push(res.data.responseBody.data[i].name)
          }
          this.MonthSalaryRank.colorList = this.colorList
          this.MonthSalaryRank.maxArr = res.data.responseBody.data[0]
        }
      });
    },

    JobNeedHandler(province,uuid) {
      let obj = {
        province:province,
        uuid:uuid
      }
      this.$axios.post(this.$apiurls.puxitu_getJobNeedTrent, obj, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.JobNeed.transverseData = []
          this.JobNeed.dataList = []
          this.JobNeed.extraData = []
          for (let i = 0; i < res.data.responseBody.data.name.length; i++) {
            this.JobNeed.transverseData.push(res.data.responseBody.data.name[i])
            this.JobNeed.dataList.push(res.data.responseBody.data.value[i])
          }
          this.JobNeed.colorList = this.colorList
          this.JobNeed.extraData = res.data.responseBody.data.extraValue
          this.JobNeed.lately = res.data.responseBody.data.extraValue[0]
          this.JobNeed.cityArr = res.data.responseBody.data.extraValue[2].value
        }
        this.formResourceBase3.city = obj.province
      });
    },
  
  }
}
</script>

<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/custom.scss" scoped></style>
<style lang="scss" scoped>
.table-search-box ::v-deep .el-input__inner {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.dataTime {
  color: #707f9d;
  font-size: 10px;
  position: relative;
  z-index: 1;
}

.project_box {
  padding: 15px 10px;
}

.notation {
  height: 40px;
  color: #fff;
  border-radius: 4px 0px 0px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep.el-form-item .el-form-item__content {
  display: flex;
  align-items: center;
}

.comparative {
  background: rgba(46, 62, 99, 0.39);
  border: 0px;
  color: rgba(27, 246, 248, 1);
  display: flex;
  align-items: center;
}

// 图表和内容高度
.graphic {
  padding: 0px 2px;
  height: 100%;
}
.figure {
  height: 100%;
}

.graphDistribute {
  position:relative;
  height: 100%;
  width: 99%;
}

.graphDistribute .el-col {
  height: calc(50% - 10px);
  border: 1px solid #707f9d;
  border-radius: 4px;
  position: relative;
}

.graphDistribute .el-col:first-child {
  margin-bottom: 20px;
}

.figure_centent {
  border: 1px solid #707f9d;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.graphic .el-col.el-col-8,
.graphicFeiquanp .el-col.el-col-8 {
  height: calc(100vh - 293px);
}

.graphicQuanping .el-col.el-col-8 {
  height: calc(100vh - 156px);
}

.skill {
  display: flex;
  flex-flow: column;
  align-items: start;
  height: 100%;
  padding: 0px 10px;
  overflow: hidden;
  width: 100%;
}

.coreSkillsTitle {
  font-size: 12px;
  color: #707f9d;
  margin-bottom: 10px;
  width: 100%;
}

.title_content {
  width: 100%;
  height: 100%;
  font-size: 12px;
  color: #707f9d;
  // padding: 10px;
  overflow: hidden;
  line-height: 25px;
}

.comparisonTitle {
  display: flex;
  justify-content: center;
  align-content: center;
}

.comparisonTitle span {
  width: 50%;
  display: inline-block;
  text-align: center;
  color: #a5a4bf;
}

.arDown_box .grid-content {
  border: 1px solid rgba(112, 127, 157, 0.5);
  border-radius: 4px;
  margin: 10px 0px;
}

.figure_title {
  position: absolute;
  top: 3%;
  left: 3%;
  font-size: 15px;
  color: #707f9d;
  display: flex;
  align-items: center;
}
.figure_title i {
  color: rgba(27, 246, 248, 1);
  margin-right: 8px;
}
</style>
<style  lang="scss" scoped>
/* 第一层 */
.firstFloor {
  height: 760px;
  position: relative;
  margin-bottom: 8px;
}
.firstFloor .el-col {
  height: 100%;
  position: relative;
}

.record {
  display: flex;
  justify-content: space-between;
  flex-flow: column;
}
/* 数据来源 */
.table-search-box {
  position:absolute;
  top:2%;
  right:0%;
  z-index:999;
}

.introduce {
  padding: 20px;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 3px;
  color: #707f9d;
}

/* 岗位词云图 */
.picture {
  position: relative;
  width: 100%;
}

.firstFloor .echartsHeight {
  width: 100%;
  height: 335px;
  // height: 270px;
}

.firstFloor .echartsHeightDemand {
  width: 100%;
  height: 714px;
}

/* 第二层 ,第三层 ,第四层,第五层  */
.sameLayer {
  position: relative;
  margin-bottom: 12px;
}

.sameLayer .el-col {
  height: 400px;
}

.sameLayer .echartsHeight {
  width: 100%;
  height: 380px;
}
.sameLayer .Fristitle {
  display: flex;
  justify-content: center;
  align-items: center;
}
.sameLayer .TitleText {
  color: #707f9d;
  font-weight: 700;
}

.Secondtitle .TitleText {
  margin-top: 100px;
  margin-left: 30px;
  font-size: 24px;
}
.city {
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  color: #707f9d;
  font-size: 22px;
}
.TextCity {
  color: #707f9d;
}
.sameLayer .text {
  color: #bcc2cf;
  font-size: 26px;
  text-align: center;
}
/* 地图 */
.mapFloor .el-col {
  height: 800px;
  position: relative;
}

.sameLayers {
  position: relative;
  margin-bottom: 12px;
}

.sameLayers .el-col {
  height: 30px;
}
.grid-content {
  position: relative;
}
.sameLayers .echartsHeight {
  width: 100%;
  height: 380px;
}
#company {
  color: #3b85fb;
}



</style>
